export default "__VITE_ASSET__CCnIh4Er__"